const useOpenpayValidation = (paymentData: any, openPay: any) => {
	const validators = {
		card: {
			value: () =>
				openPay.card.validateCardNumber(
					paymentData.card_number.replace(/\s/g, '')
				),
			get error() {
				return !this.value() && 'El número de tarjeta es inválido'
			},
		},
		cvv: {
			value: () => openPay.card.validateCVC(paymentData.cvv2),
			get error() {
				return !this.value() && 'El CVC es inválido'
			},
		},
		expiry: {
			value: () =>
				openPay.card.validateExpiry(
					paymentData.expiration_month,
					paymentData.expiration_year
				),
			get error() {
				return !this.value() && 'La fecha de expiración es inválida'
			},
		},
		holder_name: {
			value: () =>
				paymentData.holder_name.length &&
				!new RegExp(/[^a-zA-ZáéíóúñÁÉÍÓÚÑ\s]/g).test(paymentData.holder_name),
			get error() {
				return (
					!this.value() &&
					(paymentData.holder_name.length === 0 ?
						'El nombre del titular no puede estar vacío'
					:	'El nombre contiene caracteres incorrectos')
				)
			},
		},
	}

	const validatePayment = () => {
		let validPayment = false

		for (const validator in validators) {
			validPayment = validators[validator as keyof typeof validators].value()

			if (!validPayment) {
				break
			}
		}

		return validPayment
	}

	return {
		validators,
		validatePayment,
	}
}

export default useOpenpayValidation
